export default "__VITE_ASSET__7586e811__"